import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function ImprovementReportForm() {
  const [startDate, setStartDate] = useState('2024-08-26');
  const [endDate, setEndDate] = useState('2024-08-26');
  const [format, setFormat] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'start_date':
        setStartDate(value);
        break;
      case 'end_date':
        setEndDate(value);
        break;
      case 'format':
        setFormat(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here if needed
  };

  return (
    <div className=" mt-5">

      <Form
        onSubmit={handleSubmit}
        className="p-4 border rounded shadow-sm"
        style={{
          borderTop: '5px solid #007bff',
          maxWidth: '600px', // Adjust width to match original form

        }}
      >
        <fieldset>
        <h2 className="text-left mb-4" style={{ color: 'black' }}>Parameters</h2>

          <Form.Group as={Row} controlId="improvement-start-date">
            <Form.Label column md={4} className="font-weight-bold">
              Task Completion Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col md={8}>
              <Form.Control
                type="date"
                name="start_date"
                value={startDate}
                onChange={handleInputChange}
                required
                style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="improvement-end-date">
            <Form.Label column md={4} className="font-weight-bold">
              Task Completion End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col md={8}>
              <Form.Control
                type="date"
                name="end_date"
                value={endDate}
                onChange={handleInputChange}
                required
                style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="report_improvement_format">
            <Form.Label column md={4} className="font-weight-bold">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col md={8}>
              <Form.Control
                as="select"
                name="format"
                value={format}
                onChange={handleInputChange}
                style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

         <Form.Group as={Row}>
           <Col sm={{ span: 8, offset: 4 }}>
             <Link to="/AddImprovement">
               <Button
                 id="pay-per-task-submit"
                 type="button"
                 variant="primary"
                 className="w-100 mt-2"
                 style={{
                   backgroundColor: '#004aad',
                   borderColor: '#004aad',
                   marginTop: '10px',
                 }}
               >
                 Run
               </Button>
             </Link>
           </Col>
         </Form.Group>
        </fieldset>
      </Form>
      
    </div>
  );
}

export default ImprovementReportForm;
